import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';
import { GenericMoreButton } from '../index';
import { colors } from '@material-ui/core';
import moment from 'moment';

const Results = props => {
  const { className, transfers, ...rest } = props;

  const classes = useStyles();
  const currency = '฿';
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, page) => {
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography
        color="textSecondary"
        gutterBottom
        variant="body2"
      >
        {transfers.length} Records found. Page {page + 1} of{' '}
        {Math.ceil(transfers.length / rowsPerPage)}
      </Typography>
      <Card>
        <CardHeader
          action={<GenericMoreButton />}
          title="Transfer"
        />
        <Divider />
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center' }}>
                      Amount
                    </TableCell>
                    <TableCell style={{ textAlign: 'center' }}>
                      Account
                    </TableCell>
                    <TableCell style={{ textAlign: 'center' }}>
                      Receipt ID
                    </TableCell>
                    <TableCell style={{ textAlign: 'center' }}>
                      Receipt Name
                    </TableCell>
                    <TableCell style={{ textAlign: 'center' }}>Date</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>
                      Status
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transfers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(transfer => {
                      const split = transfer.paid.split('T');
                      const newCreated = `${moment(transfer.paid).format(
                        'MMM DD, YYYY'
                      )} ${split[1].substring(0, 5)}`;

                      return (
                        <TableRow
                          hover
                          key={transfer.receiptId}
                        >
                          <TableCell
                            className={clsx({
                              [classes.green]:
                                transfer.status === 'Transferred',
                              [classes.red]: transfer.status === 'Incomplete'
                            })}
                            style={{ textAlign: 'right' }}
                          >
                            {`${currency}${transfer.amount}`}
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            {transfer.account}
                          </TableCell>
                          <TableCell>{transfer.receiptId}</TableCell>
                          <TableCell>{transfer.receiptName}</TableCell>
                          <TableCell>{newCreated}</TableCell>
                          <TableCell
                            className={clsx({
                              [classes.green]:
                                transfer.status === 'Transferred',
                              [classes.red]: transfer.status === 'Incomplete'
                            })}
                            style={{ textAlign: 'center' }}
                          >
                            {transfer.status}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={transfers.length}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>
    </div>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  transfers: PropTypes.array.isRequired
};

Results.defaultProps = {
  transfers: []
};

export default Results;

const useStyles = makeStyles(theme => ({
  root: {},
  filterButton: {
    marginRight: theme.spacing(2)
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1150
  },
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end'
  },
  green: {
    color: colors.green[500]
  },
  red: {
    color: colors.red[500]
  }
}));
